export var StackCssClass;
(function (StackCssClass) {
    StackCssClass["Base"] = "iress-stack";
    StackCssClass["Gutter"] = "iress-stack__gutter";
})(StackCssClass || (StackCssClass = {}));
export var StackGutter;
(function (StackGutter) {
    StackGutter["None"] = "none";
    StackGutter["Xs"] = "xs";
    StackGutter["Sm"] = "sm";
    StackGutter["Md"] = "md";
    StackGutter["Lg"] = "lg";
    StackGutter["Xl"] = "xl";
})(StackGutter || (StackGutter = {}));
//# sourceMappingURL=stack.types.js.map